import { BrainCircuit, Compass } from "lucide-react";
import { Outlet, Link } from "react-router-dom";
import { DevDiagnostics } from "@/components/dev-diagnostics";

export function SiteLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <DevDiagnostics />
      <header className="sticky top-0 z-40 w-full border-b bg-background/80 backdrop-blur">
        <div className="mx-auto flex h-14 w-full max-w-5xl items-center gap-4 px-4">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <span className="inline-flex size-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
              <BrainCircuit className="size-4" />
            </span>
            VidQuiz
          </Link>
          <nav className="ml-auto flex items-center gap-4 text-sm font-medium">
            <Link to="/history" className="inline-flex items-center gap-1.5 text-muted-foreground transition-colors hover:text-foreground">
              <Compass className="size-4" />
              Browse
            </Link>
            <Link to="/" className="text-muted-foreground transition-colors hover:text-foreground">
              New quiz
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8">
        <Outlet />
      </main>
      <footer className="border-t">
        <div className="mx-auto w-full max-w-5xl px-4 py-4 text-sm text-muted-foreground">
          Built with Cloudflare Pages, D1 &amp; OpenRouter.
        </div>
      </footer>
    </div>
  );
}